import { render, staticRenderFns } from "./AdminViewProfile.vue?vue&type=template&id=2aaf2cb0&scoped=true&"
import script from "./AdminViewProfile.vue?vue&type=script&lang=js&"
export * from "./AdminViewProfile.vue?vue&type=script&lang=js&"
import style0 from "./AdminViewProfile.vue?vue&type=style&index=0&id=2aaf2cb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf2cb0",
  null
  
)

export default component.exports